<template>
  <div>
    <base-content-block>
      <template #title>
        <span class="card-header__item" v-if="course">{{ $t('entity.course') }} {{ course.id }}</span>
        <span class="card-header__item" v-if="courseDate">{{ courseDate }}</span>
        <span v-if="trainingsInfo" class="card-header__item"
          >{{ sessionCounterString }}: {{ trainingsInfo.done }}/{{ trainingsInfo.all }}</span
        >
        <span class="card-header__item">
          <status-title
            v-if="courseStatus"
            :status="courseStatus"
            :type="'course'"
            :is-badge="true"
          ></status-title>
        </span>
      </template>
      <template #headerRight>
        <div class="d-flex">
          <protocol-course
            v-if="trainingsInfo"
            :patient="course.patient"
            :trainings="doneTrainings"
            :course="course"
            :trainings-info="trainingsInfo"
          ></protocol-course>
          <button
            class="btn btn-primary btn-with-icon ml-3"
            :class="{ hidden: isNeuroAdmin || isReadonly }"
            @click="showChat"
          >
            <span :class="isShowChat ? 'icon icon-close icon_small' : 'icon icon-message'"></span>
            {{ isShowChat ? $t('button.closeChat') : $t('button.chat') }}
            <div v-if="isNewMessage" class="message-new-icon">
              <span>{{ countNewMess }}</span>
            </div>
          </button>
        </div>
      </template>
      <template #content>
        <div v-if="loading">
          <base-spinner></base-spinner>
        </div>
        <div v-else-if="!course">{{ $t('src/pages/coursesedit.5155') }}</div>
        <course-info-block
          v-else
          v-model="course"
          :trainings-info="trainingsInfo"
          @save:course="saveCourse"
        ></course-info-block>
        <chat
          v-if="isFirstOpen"
          v-show="isShowChat"
          :isShow="isShowChat"
          :activeChat="+courseId"
          :activeTrainings="activeTrainings"
          @close:chat="showChat"
          @change:haveNewMessage="updateHaveNewMessage"
        ></chat>
      </template>
    </base-content-block>
    <section class="card mt-3 mb-2" v-if="course">
      <div class="card-header card-header-light">
        <h4 class="card-header__title">{{ $t('src/pages/coursesedit.2000') }}</h4>
      </div>
      <div class="card-body">
        <div class="row">
          <connected-device
            class="col-xl-4 col-lg-3 col-md-3 col-12"
            :device-id="course.device_id"
          ></connected-device>
          <connected-smartphone
            :app-api-key="course.app_api_key"
            :smartphone="course.smartphone_data"
            :error="{
              text: course.unlink_error,
              isClosedWrong: isClosedWrong
            }"
            class="col-xl-5 col-lg-4 col-md-4 col-12"
          ></connected-smartphone>
          <template v-if="isManageAnyCourse">
            <div
              v-if="course.qr_code_link_token"
              class="col-xl-1 col-lg-1 col-md-1 col-12"
              style="margin-top: -40px"
            >
              <qrcode :appApiKey="course.qr_code_link_token" :width="80"></qrcode>
            </div>
            <div class="col-xl-2 col-lg-4 col-md-4 col-4 text-right" v-if="!isClosedCourse">
              <button @click="startCourseBinding" class="btn btn-outline-primary text-nowrap">
                {{ isCourseAppBound ? $t('button.bindAgain') : $t('button.bind') }}
              </button>
            </div>
          </template>
        </div>
      </div>
    </section>
    <section class="card mt-3 mb-2" v-if="course">
      <div class="card-header card-header-light">
        <h4 class="card-header__title">{{ $t('src/pages/coursesedit.3651') }}</h4>
      </div>
      <div class="card-body">
        <course-settings-block :course="course" @save:settings="saveCourse"></course-settings-block>
      </div>
    </section>
    <training-manage
      ref="manage"
      v-if="course"
      :course="course"
      :updateSessionSettings="updateSessionSettings"
      @save:course="saveCourse"
      @change:trainings="changeTrainingsInfo"
    ></training-manage>
    <section class="card mt-3 mb-2" v-if="showConclusion">
      <div class="card-header card-header-light">
        <h4 class="card-header__title">{{ $t('src/pages/coursesedit.doctorsReport') }}</h4>
      </div>
      <div class="card-body">
        <template v-if="!isEditableReport">
          <div class="term-value d-flex">
            <div style="max-width: 70%">{{ doctorReport }}</div>
            <svg-icon
              v-if="isExistsDoctorReport && isCourseCreator"
              class="ml-2 mt-1"
              :name="'edit_pen_inside_the_square'"
              :width="20"
              :height="20"
              @click:icon="openReportEditMode"
            ></svg-icon>
          </div>
          <button
            v-if="!isExistsDoctorReport && isCourseCreator"
            class="btn btn-primary mt-3"
            @click="openReportEditMode"
          >
            {{ $t('button.add') }}
          </button>
        </template>
        <template v-else>
          <base-textarea name="conclusion" ref="conclusion" v-model="course.doctor_report"></base-textarea>
          <button class="btn btn-primary mt-3" @click="saveDoctorReport">{{ $t('button.save') }}</button>
        </template>
      </div>
    </section>
    <section v-if="!isClosedCourse && isManageCourse" class="card mt-3 mb-2">
      <div
        class="card-body d-flex align-items-center"
        :class="isCourseEndBeforeNow ? 'justify-content-between' : 'justify-content-end'"
      >
        <div v-if="isCourseEndBeforeNow" class="text-danger mr-2">
          {{ $t('src/pages/coursesedit.8557', { '1': courseFormattedEndDate }) }}
        </div>
        <button v-if="isManageCourse" type="button" class="btn btn-danger" @click="showModalClosing">
          {{ $t('button.completeTheCourse') }}
        </button>
      </div>
    </section>
    <base-modal
      :is-show="isShowModalBinding"
      @close="closeModalBinding"
      @cancel="closeModalBinding"
      @confirm="deleteCourseBinding"
    >
      <template #header>{{ $t('src/pages/coursesedit.1655') }}</template>
      <template #body>{{ $t('src/pages/coursesedit.1678') }}</template>
    </base-modal>
    <base-modal
      :is-show="isShowModalClosing"
      @close="closeModalClosing"
      @cancel="closeModalClosing"
      @confirm="closeCourse"
    >
      <template #header>{{ $t('button.completeTheCourse') }}</template>
      <template #body>
        <p>{{ $t('src/pages/coursesedit.8119') }}</p>
        <p>{{ $t('src/pages/coursesedit.6676') }}</p>
      </template>
    </base-modal>
  </div>
</template>

<script>
import http from '@/modules/http.js'
import { status } from '@/main.config.js'
import { userRights } from '@/mixins/user-rights.js'
import { DATE_FORMAT, courseTypes } from '@/main.config'
import { courseDate } from '@/mixins/course-date'
import { contentTpl } from '@/mixins/content-tpl.js'
import { stringify } from 'qs'
import { trainingDate } from '@/mixins/training-date.js'
import { systemUnavailable } from '@/mixins/system-unavailable.js'

export default {
  name: 'CoursesEdit',
  components: {
    CourseInfoBlock: () => import('@/components/CourseInfoBlock.vue'),
    CourseSettingsBlock: () => import('@/components/CourseSettingsBlock.vue'),
    ConnectedSmartphone: () => import('@/components/ConnectedSmartphone'),
    ConnectedDevice: () => import('@/components/ConnectedDevice'),
    BaseSpinner: () => import('@/base/BaseSpinner.vue'),
    StatusTitle: () => import('@/components/StatusTitle.vue'),
    TrainingManage: () => import('@/components/Training/TrainingManage.vue'),
    BaseModal: () => import('@/base/BaseModal.vue'),
    Chat: () => import('@/components/Chat.vue'),
    Qrcode: () => import('@/components/Qrcode.vue'),
    ProtocolCourse: () => import('@/components/ProtocolCourse.vue'),
    BaseTextarea: () => import('@/base/BaseTextarea.vue'),
    SvgIcon: () => import('@/components/SvgIcon.vue')
  },
  mixins: [userRights, courseDate, contentTpl, trainingDate, systemUnavailable],
  data: () => ({
    course: null,
    loading: true,
    saving: false,
    courseId: null,
    serverError: null,
    trainingsInfo: null,
    doneTrainings: null,
    isShowModalBinding: false,
    isShowModalClosing: false,
    updateSessionSettings: false,
    isShowChat: false,
    isFirstOpen: false,
    haveNewMessage: false,
    countNewMessage: null,
    isEditableReport: false
  }),
  computed: {
    localeRU() {
      return this.$i18n.locale === 'ru'
    },
    isClosedCourse() {
      if (!this.course) {
        return true
      }
      return this.course.status === status.closed || this.course.status === status.closedWrong
    },
    courseStatus() {
      return this.course ? parseInt(this.course.status, 10) : null
    },
    isClosedWrong() {
      return this.course.status === status.closedWrong
    },
    courseDate() {
      if (!this.courseMomentStartDate) {
        return ''
      }
      if (!this.courseMomentEndDate) {
        return this.courseMomentStartDate.format(DATE_FORMAT[`${this.$store.getters.LOCALE}`])
      }
      return (
        this.courseMomentStartDate.format(DATE_FORMAT[`${this.$store.getters.LOCALE}`]) +
        ' - ' +
        this.courseMomentEndDate.format(DATE_FORMAT[`${this.$store.getters.LOCALE}`])
      )
    },
    isCourseAppBound() {
      return !!(this.course.smartphone_data || this.course.firebase_token)
    },
    isCourseCreateToday() {
      const createdAt = this.moment(this.course.createdAt, DATE_FORMAT.serverFull)
      return createdAt.isSame(this.nowMoment, 'day')
    },
    isNewMessage() {
      return this.haveNewMessage
    },
    activeTrainings() {
      return this.trainingsInfo ? this.trainingsInfo.active : []
    },
    countNewMess() {
      return this.countNewMessage
    },
    isExistsDoctorReport() {
      return this.course && this.course.doctor_report
    },
    doctorReport() {
      if (this.isExistsDoctorReport) return this.course.doctor_report
      else return this.$t('src/pages/coursesedit.notConclusion')
    },
    showConclusion() {
      return this.isExistsDoctorReport || this.isCourseCreator
    },
    sessionCounterString() {
      if (this.course.course_type === courseTypes.rehab)
        return this.$t('src/pages/coursesedit.8644')  //Тренировки
      else
        return this.$t('src/pages/coursesedit.8643')  //Сессии
    }
  },
  mounted() {
    this.courseId = this.$route.params.id
    this.getCourse()
  },
  methods: {
    getCourse() {
      http
        .get('/courses/' + this.courseId, {
          headers: {
            redirect404: true
          }
        })
        .then(response => {
          this.course = response.data
          this.course.training_duration = this.course.training_duration
            ? +this.course.training_duration
            : null
          this.haveNewMessage = Boolean(response.data.unread_messages)
          this.countNewMessage = response.data.unread_messages
          this.canSubscribe = true
        })
        .catch(error => console.log(error))
        .finally(() => (this.loading = false))
    },
    saveCourse(data, updateSessionSettings) {
      const isUpdate = Object.keys(data).some(key => data[key] != this.course[key])
      if (isUpdate) {
        this.saving = true
        http
          .patch('/courses/' + this.courseId, data)
          .then(response => {
            this.course = response.data
            this.course.training_duration = this.course.training_duration
              ? +this.course.training_duration
              : null
          })
          .catch(error => {
            if (error.response.data.message === 'The system has expired') {
              this.$emit('system:unavailable')
            }
            this.serverError = error.response.status
          })
          .finally(() => {
            this.saving = false
          })
      }
      if (updateSessionSettings) {
        const dateCondition = this.isCourseCreateToday ? '$gte' : '$gt'
        const new_data = {
          heart_rate_min: data.opt_watch_hr ? data.course_hr_min : null,
          heart_rate_max: data.opt_watch_hr ? data.course_hr_max : null,
          duration: data.opt_show_duration
            ? this.getDurationInMinutes(data.training_duration, data.training_duration_unit)
            : null
        }
        this.updateSessionSettings = updateSessionSettings
        http
          .patch('/trainings/', new_data, {
            params: {
              course_id: this.courseId,
              date_plan: {
                [dateCondition]: this.nowFormatServer
              }
            },
            paramsSerializer: params => stringify(params, { arrayFormat: 'brackets' })
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    changeTrainingsInfo(data) {
      this.trainingsInfo = data
      this.doneTrainings = data.doneTrainingsForProtocol
    },
    startCourseBinding() {
      if (Number(localStorage.getItem('activeHospital'))) {
        if (this.isCourseAppBound) {
          this.isShowModalBinding = true
        } else {
          this.goToCourseBinding()
        }
      } else {
        this.$emit('system:unavailable')
      }
    },
    deleteCourseBinding() {
      http
        .patch('/courses/' + this.courseId, {
          link_pin_create_time: null,
          link_pin: null
        })
        .then(() => {
          this.goToCourseBinding()
        })
        .catch(error => console.log(error))
    },
    goToCourseBinding() {
      this.$router.push({
        name: 'course-binding',
        params: { id: this.course.id, isBoundAgain: true, oldAppApiKey: this.course.app_api_key }
      })
    },
    closeModalBinding() {
      this.isShowModalBinding = false
    },
    showModalClosing() {
      this.isShowModalClosing = true
    },
    closeModalClosing() {
      this.isShowModalClosing = false
    },
    closeCourse() {
      // если привязано приложение то отправляемся на страницу закрытия курса
      // если привязки к приложению нет, то просто обновляем статус курса
      if (this.isCourseAppBound) {
        this.$router.push({
          name: 'course-closing',
          params: { id: this.courseId }
        })
      } else {
        this.saveCourse({
          status: status.closed
        })
        this.closeModalClosing()
      }
    },
    showChat() {
      this.isShowChat = !this.isShowChat
      this.isFirstOpen = true
      this.haveNewMessage = false
      this.countNewMessage = 0
    },
    updateHaveNewMessage() {
      if (!this.isShowChat) {
        this.haveNewMessage = true
        this.countNewMessage++
      }
    },
    openReportEditMode() {
      this.isEditableReport = true
    },
    saveDoctorReport() {
      this.saving = true
      http
        .patch('/courses/' + this.courseId, {
          doctor_report: this.course.doctor_report
        })
        .then(response => {
          this.course.doctor_report = response.data.doctor_report
        })
        .catch(error => {
          if (error.response.data.message === 'The system has expired') {
            this.$emit('system:unavailable')
          }
          this.serverError = error.response.status
        })
        .finally(() => {
          this.saving = false
          this.isEditableReport = false
        })
    }
  }
}
</script>
